import { Injectable } from "@angular/core";

@Injectable()
export class Utils {

  /**
   * Форматирует секунды в дни, часы, минуты и секунды
   * @param totalSeconds
   */
  public formatTime(totalSeconds: number): string {

    var time = totalSeconds;

    const secondsInDay = 86400;

    var days = Math.floor(time / secondsInDay);
    var hours = Math.floor((time - days * 86400) / 3600);
    var minutes = Math.floor((time - days * 86400 - hours * 3600) / 60);
    var seconds = Math.floor(time - days * 86400 - hours * 3600 - minutes * 60);

    var parts = [
      this.formatPart(days, "day", "days"),
      this.formatPart(hours, "hour", "hours"),
      this.formatPart(minutes, "minute", "minutes"),
      this.formatPart(seconds, "second", "seconds")
    ];

    var result = "";

    for (let part of parts.filter(x => x.length > 0)) {

      if (result.length > 0) {
        result += ", ";
      }
      result += part;
    }

    return result;
  }

  private formatPart(count: number, singleForm: string, multipleForm): string {

    if (count <= 0) {
      return "";
    }

    if (count > 1) {
      return `${count} ${multipleForm}`;
    }

    return `${count} ${singleForm}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils.ts